module.exports = XMLHttpRequest;



//////////////////
// WEBPACK FOOTER
// ./~/xhr2/lib/browser.js
// module id = 1959
// module chunks = 4